import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/maintenance-and-relapse")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "what-happens-after-saint-tms" },
      statusCode: 301,
    });
  },
});
